import type { VisibilityCondition } from '../core/schema/types';

export function evaluateCondition(
  condition: VisibilityCondition,
  row: Record<string, unknown>,
): boolean {
  if ('logic' in condition) {
    const compound = condition;
    if (compound.logic === 'AND') {
      return compound.conditions.every((c) => evaluateCondition(c, row));
    }
    return compound.conditions.some((c) => evaluateCondition(c, row));
  }

  const simple = condition;
  const rowValue = row[simple.field];
  const operator = simple.operator ?? 'EQUAL';

  switch (operator) {
    case 'EQUAL':
      return rowValue === simple.value;
    case 'NOT_EQUAL':
      return rowValue !== simple.value;
    case 'IN':
      return Array.isArray(simple.value) && simple.value.includes(rowValue);
    case 'NOT_IN':
      return Array.isArray(simple.value) && !simple.value.includes(rowValue);
    case 'GT':
      return Number(rowValue) > Number(simple.value);
    case 'LT':
      return Number(rowValue) < Number(simple.value);
    case 'GTE':
      return Number(rowValue) >= Number(simple.value);
    case 'LTE':
      return Number(rowValue) <= Number(simple.value);
    case 'TRUTHY':
      return Boolean(rowValue);
    case 'FALSY':
      return !rowValue;
    default:
      return rowValue === simple.value;
  }
}
